import { useCallback, useEffect } from 'react'

import { doc, onSnapshot, type DocumentSnapshot } from 'firebase/firestore'
import { useAtomValue } from 'jotai'

import { PROMPTER_COLLECTION } from '~shared/consts'

import { db } from '../../firebase.js'
import { createPrompter } from '../../firestore.js'
import { rundownAtom } from '../../store/rundown.store.js'

export const usePrompterListener = (
  callback: (snapshot: DocumentSnapshot) => void,
) => {
  const rundown = useAtomValue(rundownAtom)
  const rundownId = rundown?.id
  const prompterId = rundown?.prompterId

  const handleCreatePrompter = useCallback(async () => {
    await createPrompter(rundownId)
  }, [rundownId])

  // useEffect: Firestore subscription to the prompter doc, resubscribed when
  // the rundown's prompterId changes. External side effect, no alternative.
  useEffect(() => {
    if (!rundownId) return
    if (!prompterId) {
      void handleCreatePrompter()
      return
    }

    return onSnapshot(doc(db, PROMPTER_COLLECTION, prompterId), callback)
  }, [callback, handleCreatePrompter, prompterId, rundownId])
}
